module.exports = __webpack_public_path__ + "img/GMB.d448e057.svg";